import config from 'Cloud/config';
import type { PhonePublicEditorCfg } from 'server/helpers/editors/types';

const PHONE_PUBLIC_EDITOR_CFG: PhonePublicEditorCfg = config.get('PHONE_PUBLIC_EDITOR_CFG') || {};

export const { IS_GO_TO_PHONE_PUBLIC_EDITOR_STEP, IS_USE_PHONE_PUBLIC_EDITOR_STEP, PHONE_PUBLIC_EDITOR_ENABLED } = PHONE_PUBLIC_EDITOR_CFG;
